// Azure MSAL Configuration
const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
        redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
        authority: process.env.REACT_APP_AZURE_AUTHORITY,
    },
};

// Contentful Configuration
const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const environment = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT;
const accessToken = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;
const management_token = process.env.REACT_APP_CONTENTFUL_MANAGEMENT_TOKEN;

// Backend Configuration
const local_backend = process.env.REACT_APP_BACKEND_URL;

// Chatbot Configuration
const chatbot_name = process.env.REACT_APP_CHATBOT_NAME;

// OpenAI Configuration
const openapikey = process.env.REACT_APP_OPENAI_API_KEY;
const assistantId = process.env.REACT_APP_OPENAI_ASSISTANT_ID;
const openAIBaseUrl = process.env.REACT_APP_OPENAI_BASE_URL;

export {
    msalConfig,
    spaceId,
    environment,
    accessToken,
    management_token,
    local_backend,
    chatbot_name,
    openapikey,
    assistantId,
    openAIBaseUrl
}
